var Curriculog = Curriculog || {};
Curriculog.ProposalToolbox = Curriculog.ProposalToolbox || {};

Curriculog.ProposalToolbox.ProposalLookupView = (function ($, _, Backbone, ProposalLookupView) {

    ProposalLookupView = Backbone.View.extend({

		el: '#proposal-lookup-view',

		events: {
			'click button[name="close-proposal-lookup-view"]': 'closeView',
		},

		initialize: function(options) {
			var that = this;
			var proposalID = this.model.id,
				proposalType = this.model.get('type');

			this.params = options.params;

			$.ajax({
				url: '/proposalTracking:' + proposalID + '/trackEditsDiff',
				type: 'GET',
				data: {
					display: "getFormAndUsers",
					showOriginal: 0,
					edits: false,
					showMarkup: 1
				},
				beforeSend: function() {
					objDom.addLoadingMask(that.el);
				},
				success: function(result) {
          var result = $(result);
          that.initTrackingMarkup(result);
				}
			});

		},

		initTrackingMarkup: function(result) {
      var form = result.filter('#form');

      var styles = result.filter('#editor-styles').html();
      var tooltips = result.filter('#edit-tooltips');
      // form
      $('#proposal-lookup-view-content').html(form);

      // styles
      $('#editor-styles').append(styles);
      $('fieldset.section-fieldset').addClass('proposal-page'); // needed to get the colors to appear

      // tooltips
      form.append(tooltips);

      // get curriculum if program proposal
      var richText = false;
      var proposalType = this.model.get('type');
      if (proposalType === 'program') {
        richText = true;
        var curriculumField = form.find('fieldset.prospectiveCurriculum, fieldset.curriculum');
        var curriculumDisplayName = curriculumField.find('.legend:first').html();
        var displayPreviewStatus = $('#displayCurriculumStatus').val() == 1;
        var proposalID = this.model.id;

        var comparisonCurriculum = new Curriculog.AcalogStaticCurriculum({
          'richText': richText,
          'edits': false,
          'canImport': false,
          'proposalID': proposalID,
          'active': true,
          'displayPreviewStatus': displayPreviewStatus,
          'displayText': curriculumDisplayName,
          'cui_enabled': this.params.cui_enabled
        });

        curriculumField.replaceWith(comparisonCurriculum.el);
      }

      // activate tool tip
      form.find('.qtip .edit-tooltip').closest('.qtip').remove();
      form.find('.edit-tip').each(function(){
        var id = $(this).data('id');
        $(this).qtip({
          content: form.find('.edit-tooltip.edit-' + id).clone(),
          show: {ready: false},
          style: {tip: true}
        });
      });

      objDom.removeMask(this.el);

      Backbone.trigger('form:stretch');
		},

		render: function() {
			return nunjucks.render('ProposalToolbox/proposalLookupView.html',
				{
					proposal: this.model.attributes,
          cui_enabled: this.params.cui_enabled
				}
			);
		},

		closeView: function (event) {
			event && event.preventDefault();
			this.$el.empty();
			this.undelegateEvents();
			this.trigger('toggle-proposal-lookup');
		}


	});

	return ProposalLookupView;

})($, _, Backbone, Curriculog.ProposalToolbox.ProposalLookupView || {});
